import React from 'react';
import { Title } from './styles';

const TABLE_TYPE_LABELS = {
  table: (table) => `Mesa ${table.table_number}`,
  delivery: () => 'Delivery',
  balcony: () => 'Balcão',
  'drive-thru': () => 'Drive-Thru',
};

const CHANNEL_LABELS = {
  ifood: (isWithdrawal) => isWithdrawal ? 'Retirada - Ifood' : 'Delivery - Ifood',
  neemo: () => 'Delivery Neemo',
  wabiz: () => 'Delivery Wabiz',
  '99food': () => 'Delivery 99Food',
};

function getTitle(channel, table, isWithdrawal) {
  if (isWithdrawal && channel !== 'ifood') {
    return table.table_type === 'balcony' ? 'Balcão' : 'Retirada';
  }

  if (CHANNEL_LABELS[channel]) {
    return CHANNEL_LABELS[channel](isWithdrawal);
  }

  const tableLabel = TABLE_TYPE_LABELS[table.table_type];
  return tableLabel ? tableLabel(table) : '';
}

export default function ChannelTag({ channel, table, isWithdrawal }) {
  return <Title>{getTitle(channel, table, isWithdrawal)}</Title>;
}